import { Platform } from '@angular/cdk/platform';
import { Component, HostBinding } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cookie-consent',
  imports: [RouterModule, MatButtonModule],
  templateUrl: './cookie-consent.html',
  styleUrl: './cookie-consent.scss',
})
export class CookieConsent {
  @HostBinding('class.hidden')
  boolean = true;
  constructor(private platform: Platform) {
    if (this.platform.isBrowser) {
      localStorage.getItem('cookie-consent') === 'accepted'
        ? (this.boolean = true)
        : (this.boolean = false);
    }
  }

  acceptCookies() {
    localStorage.setItem('cookie-consent', 'accepted');
    this.boolean = true;
  }
}
